import { render } from "./MenuSimple.vue?vue&type=template&id=63044e58&scoped=true"
import script from "./MenuSimple.vue?vue&type=script&lang=js"
export * from "./MenuSimple.vue?vue&type=script&lang=js"

import "./MenuSimple.vue?vue&type=style&index=0&id=63044e58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63044e58"]])

export default __exports__